var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-container",
        { attrs: { fluid: "", white: "" } },
        [
          _c(
            "div",
            { attrs: { align: "left" } },
            [_c("FormFieldsContainer")],
            1
          ),
          _c("v-divider"),
          _c(
            "div",
            {},
            [
              _c(
                "v-layout",
                {
                  staticClass: "add-equipos-toolbar",
                  attrs: { row: "", wrap: "" }
                },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "add-equipos-toolbar__buscar",
                      attrs: { xs12: "", sm4: "", md3: "" }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Buscar...",
                          outlined: "",
                          dense: "",
                          "append-icon": "search",
                          clearable: ""
                        },
                        on: {
                          keyup: _vm.handleQuickSearch,
                          "click:clear": _vm.handleQuickSearch
                        },
                        model: {
                          value: _vm.quickSearch,
                          callback: function($$v) {
                            _vm.quickSearch = $$v
                          },
                          expression: "quickSearch"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      staticClass: "add-equipos-toolbar__series",
                      attrs: { xs12: "", sm8: "", md6: "" }
                    },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Numeros de Series",
                          outlined: "",
                          dense: "",
                          rows: "2",
                          "auto-grow": "",
                          clearable: "",
                          hint:
                            "Pegue las series para filtrar la grilla y seleccionarlas automáticamente",
                          "persistent-hint": ""
                        },
                        model: {
                          value: _vm.bulkSeriesText,
                          callback: function($$v) {
                            _vm.bulkSeriesText = $$v
                          },
                          expression: "bulkSeriesText"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "gridcard rounded-card" },
                [
                  _c("AgGridVue", {
                    staticClass: "ag-theme-material",
                    staticStyle: { "font-family": "'Asap', sans-serif" },
                    attrs: { gridOptions: _vm.gridOptions }
                  })
                ],
                1
              ),
              _c(
                "v-layout",
                { staticClass: "mt-3", attrs: { row: "", wrap: "" } },
                [
                  _c("v-flex", { attrs: { xs8: "", sm8: "", md9: "" } }),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "text-align": "end" },
                      attrs: { xs4: "", sm4: "", md3: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-volver white--text",
                          on: {
                            click: function($event) {
                              return _vm.ClosedModal()
                            }
                          }
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-grabar white--text",
                          on: {
                            click: function($event) {
                              return _vm.save()
                            }
                          }
                        },
                        [_vm._v("Guardar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }